import {combineReducers}    from "redux"
import Guideline            from "./Guideline"
import PacingRatio          from "./PacingRatio"

export default combineReducers({
  Guideline,
  PacingRatio,
})
